module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-00.aa64ad8d.png";